import React, { useMemo } from 'react';
import { ActionButton } from '@adobe/react-spectrum';
import { toCSSColor } from '@printu/geom';
export const ColorButton = (props) => {
    const { color, onPress: $onPress } = props;
    const onPress = useMemo(() => ($onPress ? () => $onPress(color) : undefined), [color, $onPress]);
    return (React.createElement(ActionButton, { isQuiet: true, width: props.width, height: props.height, "data-test-id": "color-picker-trigger", onPress: onPress, UNSAFE_style: {
            backgroundColor: toCSSColor(props.color),
        } },
        React.createElement("span", null, "\u00A0")));
};
